// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.104.1_esbuild@0.27.2_/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.104.1_esbuild@0.27.2_/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-row ion-col div ion-avatar {
  width: 165px;
  height: 165px;
  margin: 0px auto 17px auto;
}
ion-row ion-col div h1 {
  font-family: "Roboto", sans-serif;
  font-size: 30px;
  font-weight: 900;
  color: #515c6f;
}
ion-row ion-col div h6 {
  font-size: 15px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.33;
  letter-spacing: normal;
  color: #515c6f;
}
.expand {
  overflow: hidden;
  margin: 0px 16px;
  border-radius: 20px 20px 0px 0px;
}

.item-avatar {
  box-shadow: 0 8px 15px 0 #e7eaf0;
}

.cam-icon {
  opacity: 0.9;
  width: 165px;
  height: 165px;
  font-size: 4.6rem;
  background-color: #f5f5f5;
  line-height: 75px;
  color: #ffffff;
  clip-path: circle();
  display: block;
  margin: auto;
  margin-bottom: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
}

#parent_pic {
  position: relative;
  margin: 30px 0;
}

#imgPic {
  opacity: 0.5;
  width: 165px;
  height: 165px;
  clip-path: circle();
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  margin: auto;
}

#input_file {
  position: absolute;
  top: 0;
  left: 0;
  opacity: 0;
  right: 0;
  z-index: 9999;
}

.add-icon {
  font-size: 26px;
  position: absolute;
  top: 180px;
  right: 30%;
  margin: auto;
  border: 4px solid;
  border-radius: 50%;
  width: 41px;
  height: 41px;
  text-align: center;
  background: #ffffff;
  color: white;
  font-weight: bold;
  display: flex;
  justify-content: center;
  align-items: center;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/components/user-profile/user-profile.component.scss"],"names":[],"mappings":"AAKM;EACE,YAAA;EACA,aAAA;EACA,0BAAA;AAJR;AAMM;EACE,iCAXD;EAYC,eAAA;EACA,gBAAA;EACA,cAAA;AAJR;AAOM;EACE,eAAA;EACA,gBAAA;EACA,oBAAA;EACA,kBAAA;EACA,iBAAA;EACA,sBAAA;EACA,cAAA;AALR;AAcA;EACE,gBAAA;EACA,gBAAA;EACA,gCAAA;AAZF;;AAeA;EACE,gCAAA;AAZF;;AAeA;EACE,YAAA;EACA,YAAA;EACA,aAAA;EACA,iBAAA;EACA,yBAAA;EACA,iBAAA;EACA,cAAA;EACA,mBAAA;EACA,cAAA;EACA,YAAA;EACA,mBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AAZF;;AAeA;EACE,kBAAA;EACA,cAAA;AAZF;;AAeA;EACE,YAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,YAAA;AAZF;;AAeA;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,UAAA;EACA,QAAA;EACA,aAAA;AAZF;;AAeA;EACE,eAAA;EACA,kBAAA;EACA,UAAA;EACA,UAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,YAAA;EACA,iBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AAZF","sourcesContent":["$font: 'Roboto', sans-serif;\n\nion-row {\n  ion-col {\n    div {\n      ion-avatar {\n        width: 165px;\n        height: 165px;\n        margin: 0px auto 17px auto;\n      }\n      h1 {\n        font-family: $font;\n        font-size: 30px;\n        font-weight: 900;\n        color: #515c6f;\n      }\n\n      h6 {\n        font-size: 15px;\n        font-weight: 500;\n        font-stretch: normal;\n        font-style: normal;\n        line-height: 1.33;\n        letter-spacing: normal;\n        color: #515c6f;\n      }\n\n      ion-button {\n      }\n    }\n  }\n}\n\n.expand {\n  overflow: hidden;\n  margin: 0px 16px;\n  border-radius: 20px 20px 0px 0px;\n}\n\n.item-avatar {\n  box-shadow: 0 8px 15px 0 #e7eaf0;\n}\n\n.cam-icon {\n  opacity: 0.9;\n  width: 165px;\n  height: 165px;\n  font-size: 4.6rem;\n  background-color: #f5f5f5;\n  line-height: 75px;\n  color: #ffffff;\n  clip-path: circle();\n  display: block;\n  margin: auto;\n  margin-bottom: 20px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n#parent_pic {\n  position: relative;\n  margin: 30px 0;\n}\n\n#imgPic {\n  opacity: 0.5;\n  width: 165px;\n  height: 165px;\n  clip-path: circle();\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  margin: auto;\n}\n\n#input_file {\n  position: absolute;\n  top: 0;\n  left: 0;\n  opacity: 0;\n  right: 0;\n  z-index: 9999;\n}\n\n.add-icon {\n  font-size: 26px;\n  position: absolute;\n  top: 180px;\n  right: 30%;\n  margin: auto;\n  border: 4px solid;\n  border-radius: 50%;\n  width: 41px;\n  height: 41px;\n  text-align: center;\n  background: #ffffff;\n  color: white;\n  font-weight: bold;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
